export default "__VITE_ASSET__BAeEfIRH__"